import fetchSinisters from './fetchSinisters'
import sendSinisterPackage from './sendSinisterPackage'
import updateSinisterPackage from './updateSinisterPackage'
import fetchPackages from './fetchPackages'
import fetchFiles from './fetchFiles'
import dollar2peso from './dollar2peso'
import sendApprovedPackage from './sendApprovedPackage'
import fetchSinisterPackageById from './fetchSinisterPackageById'
import setVisible4Customer from './setVisible4Customer'
import getPaymentsPerPackage from './getPaymentsPerPackage'
import sendPayment from './sendPayment'
import fetchCostomerpackege from './fetchCostomerpackege'
import fetchBinnacle from './fetchBinnacle'
import sendBinnacle from './sendBinnacle'
import fetchePackageZip from './fetchePackageZip'
import fetchTaggableUsers from './fetchTaggableUsers'

/**
 * @author Andrés Aguilar <andresyoshimar@gmail.com>
 */

export default {
  fetchFiles,
  sendPayment,
  dollar2peso,
  sendBinnacle,
  fetchBinnacle,
  fetchPackages,
  fetchSinisters,
  sendSinisterPackage,
  sendApprovedPackage,
  setVisible4Customer,
  updateSinisterPackage,
  getPaymentsPerPackage,
  fetchSinisterPackageById,
  fetchCostomerpackege,
  fetchePackageZip,
  fetchTaggableUsers,
}


// WEBPACK FOOTER //
// ./src/services/extranet/index.js